<template>
  <div>
    <el-dialog :visible.sync="addUseTimeBox" width="80%" :show-close="false" class="addFast" :close-on-click-modal="false">
      <div class="title">
        <p>快速生成预算</p>
        <p>(您将按照下方信息生成预算，订单产生后若无后台供应商接单，则订单自动失效)</p>
      </div>
      <ul class="order_list">
        <li v-for="(item,index) in orderType" :key="index">
          <div class="typeDiv">{{item.type}}</div>
          <div style="width:20px;height:19px;cursor:pointer;margin:2px 0 2px 4px;background-color: #02A0C6;" @click="addProduct(item)"
            v-if="item.state!=-1">
            <img src="@/assets/png/addService.png" alt="" width="100%">
          </div>
        </li>
        <div style="color:red;margin-left:20px" v-if="totalPrice.length>0">
          成本总金额：<span v-for="(item,index) in totalPrice" :key="index">{{item.price}}{{item.currency}}</span>
        </div>
        <div style="color:red;margin-left:20px" v-if="saleTotalPrice.length>0">
          报价总金额：<span v-for="(item,index) in saleTotalPrice" :key="index">{{item.price}}{{item.currency}}</span>
        </div>
      </ul>
      <div class="tableTitle">
        <span style="width:1.8rem" class="label">日期</span>
        <span class="label" style="width:0.3rem">类型</span>
        <span class="label" style="width:1.5rem">资源名称</span>
        <span class="label" style="width:1.5rem">产品名称</span>
        <span class="label" style="width:1.5rem">产品描述</span>
        <span class="label" style="width:0.6rem">单位</span>
        <span class="label" style="width:0.6rem">时长</span>
        <span class="label" style="width:0.6rem">数量</span>
        <span class="label" style="width:0.6rem">币种</span>
        <span class="label" style="width:0.8rem">单项成本</span>
        <span class="label" style="width:0.8rem">单项报价</span>
        <span class="label" style="width:0.8rem">票据号</span>
        <!-- <span class="label" style="width:1.2rem">单项利润</span>
        <span class="label" style="width:2rem">总成本</span>
        <span class="label" style="width:2rem">总报价</span>
        <span class="label" style="width:1.5rem">总利润</span> -->
        <span class="label" style="width:0.5rem">操作</span>
      </div>
      <div style="position: absolute;">
        <div class="dayQuan" v-for="(item,index) in checkBudgetDetail.planDayList" :key="index" 
          @click="goToDay(item.planDay)" :style="item.planDay==checkPlanDay?'background: #da4e1a;color: #fff;':''">D{{item.planDay}}</div>
      </div>
      <div :style="'display: flex;overflow-y: scroll;margin-left: 0.4rem;height:'+height+'px'">
        <div>
          <div class="daybox" v-for="(item,index) in checkBudgetDetail.planDayList" :key="index" :id="'changeTimeDay'+item.planDay" 
            :style="item.planDay==checkPlanDay?'box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);':''">
            <div style="width: 1.7rem;">
              <label>{{dateFormatYMD(item.planDate,".")}}&nbsp;</label>
              <label>
                <span v-for="(item1,index1) in item.cityList" :key="index1">{{item1.cityName}}
                  <span v-if="index1!=(item.cityList.length-1)">-</span>
                </span>
              </label>
            </div>
            <div>
              <draggable v-model="item.productList" group="itxst" animation="300" @add="addCommand">
                <transition-group :style="style" :id="item.planDate">
                  <div v-for="(item1,index1) in item.productList" :key="index+'-'+index1" class="productBox" @mouseover="checkPlanDay=item.planDay" 
                    :style="item.planDay==checkPlanDay?'box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);':''">
                    <span class="labelone textspan" style="width:0.3rem;"><span>{{item1.productTypeName}}</span></span>
                    <span class="labelone textspan" style="width:1.5rem;">
                      <span v-if="item1.isEdit">
                        <el-autocomplete v-model="item1.resourceNameCn" :fetch-suggestions="((queryString,cb)=>{querySearchResource(queryString,cb,item)})" 
                          placeholder="请输入资源名称" @select="handleSelect($event,item1)">
                          <template slot-scope="{ item }">
                            <div class="name">{{item.nameCn&&item.nameCn!=''?item.nameCn:item.nameEn}}</div>
                          </template>
                        </el-autocomplete>
                      </span>
                      <span v-else>{{item1.resourceNameCn}}</span>
                    </span>
                    <span class="labelone textspan" style="width:1.5rem;">
                      <span v-if="item1.isEdit">
                        <el-select v-model="item1.details[0].productName" placeholder="请输入产品名称" filterable allow-create 
                          @change="changeSelect($event,item1)">
                          <el-option v-for="(item2,index2) in item1.checkProductList" :key="index2" :value="item2.stockId" 
                            :label="item2.budgetType+item2.productNameCn+item2.productDesc+item2.stockDesc+(item2.priceList.length>0?item2.priceList[0].price 
                            +item2.priceList[0].currency+item2.priceList[0].priceCompany+item2.priceList[0].useTime:'')"></el-option>
                        </el-select>
                      </span>
                      <span v-else>{{item1.details[0].productName}}</span>
                    </span>
                    <span class="labelone textspan" style="width:1.5rem;">
                      <span v-if="item1.isEdit">
                        <el-input v-model="item1.details[0].stockDetailObj.productDesc" placeholder="请输入"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].stockDetailObj.productDesc}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.6rem;">
                      <span v-if="item1.isEdit">
                        <el-input v-model="item1.details[0].stockDetailObj.priceList[0].priceCompany" placeholder="请输入"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].stockDetailObj.priceList[0].priceCompany}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.6rem;">
                      <span v-if="item1.isEdit">
                        <el-input v-model="item1.details[0].stockDetailObj.priceList[0].useTime" placeholder="请输入"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].stockDetailObj.priceList[0].useTime}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.6rem;">
                      <span v-if="item1.isEdit">
                        <el-input v-model="item1.details[0].stockNumber" class="def-input-number" type="number" min="1" step="1" placeholder="请输入" @change="changePrice()"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].stockNumber}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.6rem;">
                      <span v-if="item1.isEdit">
                        <currency-autocomplete :obj="item1.details[0]"></currency-autocomplete>
                      </span>
                      <span v-else>{{item1.details[0].currency}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.8rem;">
                      <span v-if="item1.isEdit">
                        <el-input class="def-input-number" v-model="item1.details[0].stockPrice" @change="changePrice()" type="number" placeholder="请输入"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].stockPrice}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.8rem;">
                      <span v-if="item1.isEdit">
                        <el-input class="def-input-number" v-model="item1.details[0].ratio" @change="changePrice()" type="number" placeholder="请输入"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].ratio}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.8rem;">
                      <span v-if="item1.isEdit">
                        <el-input class="def-input-number" v-model="item1.details[0].stockDetailObj.billNumber" placeholder="请输入"></el-input>
                      </span>
                      <span v-else>{{item1.details[0].stockDetailObj.billNumber}}</span>
                    </span>
                    <span class="labelone textspan" style="width:0.6rem;">
                      <i class="el-icon-document-copy" style="font-size: 0.2rem;" @click="copyData(item1)"></i>
                      <i class="el-icon-circle-close" style="font-size: 0.2rem;" @click="delData(item.productList,index1,item1)"></i>
                    </span>
                  </div>
                </transition-group>
              </draggable>
            </div>  
          </div>
        </div>
      </div>
      <div style="justify-content: center;display: flex;padding: 0.1rem;">
        <div>
          <el-button @click="addUseTime" class="savebuttom" :loading="addUseTimeLoading">保存</el-button>
          <el-button @click="closeDialog" class="savebuttom" style="margin-left:75px;">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="copyToOtherDay" width="12%">
      <el-checkbox v-model="checkDayListFlag" @change="allCheck">全选</el-checkbox>
      <el-checkbox-group v-model="checkDayList">
        <div v-for="(item,index) in checkBudgetDetail.planDayList" :key="index">
          <el-checkbox :label="item.planDay">D{{item.planDay}} {{dateFormatYMD(item.planDate,".")}}</el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyToOtherDay = false">取 消</el-button>
        <el-button type="primary" @click="sureCopy">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBudgetInfo } from '../../js/function'
import Api from '@/components/Api/index.js'
import CurrencyAutocomplete from '../../../common/currencyAutocomplete.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import draggable from 'vuedraggable'
import {stockTypeMap} from '@/assets/utils/commonData'
export default {
  components:{CurrencyAutocomplete,draggable},
  data(){
    return{
      addUseTimeBox:false,
      height:0,
      checkBudgetDetail:{},
      orderType:[{
        type:'全',
        state:-1,
      },{
        type:'酒',
        state:0,
      },{
        type:'会',
        state:1,
      },{
        type:'景',
        state:2,
      },{
        type:'车',
        state:3,
      },{
        type:'交',
        state:15,
      },{
        type:'餐',
        state:4,
      },{
        type:'导',
        state:5,
      },{
        type:'签',
        state:6,
      },{
        type:'公',
        state:10,
      },{
        type:'体',
        state:8,
      },{
        type:'商',
        state:7,
      },{
        type:'其',
        state:14,
      }],
      totalPrice:[],
      saleTotalPrice:[],
      checkedOrderType:0,
      checkPlanDay:0,
      copyToOtherDay:false,
      checkDayList:[],
      checkDayListFlag:false,
      addProductObj:{
        state:null,
        productType:10,
        stayDate:null,
        day:null,
        resourceNameCn:null,
        productTypeName:'',
        details:[{
          productName:null,
          stockPrice:null,
          stockNumber:null,
          stockDetailObj:{
            productDesc:null,
            billNumber:null,
            priceList:[{
              priceCompany:null,
              useTime:null,
            }]
          },
          currency:null,
          ratio:null,
        }]
      },
      copyDataObj:{},
      addUseTimeLoading:false,
      style: "min-height:20px;display: block;min-width: 600px;",
      stockTypeMap,
    }
  },
  methods:{
    changePrice(){
      this.totalPrice = []
      this.saleTotalPrice = []
      this.checkBudgetDetail.planDayList.forEach(eee=>{
        eee.productList.forEach(eeee=>{
          this.countPrice(this.totalPrice,eeee,'stockPrice')
          this.countPrice(this.saleTotalPrice,eeee,'ratio')
        })
      })   
    },
    countPrice(arr,eeee,propName,flag){
      var price = Number(eeee.details[0][propName])*eeee.details[0].stockNumber
      var currency = eeee.details[0].currency
      var obj = arr.find(ee=>ee.currency==currency)
      if(!obj){
        arr.push({
          "price":price.toFixed(2),
          "currency":currency
        })
      }else{
        if(flag=='-'){
          obj.price = (obj.price-price).toFixed(2)
        }else{
          obj.price = (Number(obj.price)+price).toFixed(2)
        }
      }
    },
    allCheck(){
      if(this.checkDayListFlag){
        this.checkBudgetDetail.planDayList.forEach(e=>{ 
          if(!(this.copyDataObj&&this.copyDataObj.day==e.planDay)){
            this.checkDayList.push(e.planDay)
          }
        })
      }else{
        this.checkDayList=[]
      }
    },
    addCommand(e){
      this.checkBudgetDetail.planDayList.forEach(e=>{  
        e.productList.forEach(ee=>{
          this.$set(ee,'day',e.planDay)
          this.$set(ee,'stayDate',this.dateFormatYMD(e.planDate,"-"))
        })
      })
    },
    openBefore(){
      this.addUseTimeBox = true;
      this.totalPrice=[]
      this.saleTotalPrice=[]
      this.checkBudgetDetail.planDayList.forEach(e=>{
        this.$set(e,'productList',[])
      })
    },
    goToDay(planDay){
      this.checkPlanDay=planDay
      document.getElementById('changeTimeDay'+planDay).scrollIntoView()
    },
    addUseTime(){
      var list = []
      this.addUseTimeLoading = true
      this.checkBudgetDetail.planDayList.forEach(e=>{
        if(e.productList){
          e.productList.forEach(ee=>{
            var obj = JSON.parse(JSON.stringify(ee))
            if(obj.checkProductList){
              obj.checkProductList=[]
            }
            obj.details[0].stockDetail = JSON.stringify(obj.details[0].stockDetailObj)
            obj.details[0].stockDetailObj = {}
            obj.planId = this.checkBudgetDetail.planId
            obj.budgetMainId = this.checkBudgetDetail.id
            obj.endStayDate = obj.stayDate
            list.push(obj)
          })
        }
      })
      if(this.addUseTimeLoading){
        new PlanApi('plan').addList(list).then(res => {
          if (res.status == 200) {
            this.addUseTimeBox  =false
            this.addUseTimeLoading = false
            getBudgetInfo(this.$store.state.budgetMainId)
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        }) 
      }
    },
    querySearchResource(queryString, cb,item) {
      new Api('resource').fastStockList({page:1,size:20,q:{
        keyword:queryString,
        productType:0,
        startDate:this.dateFormatYMD(item.planDate,"-"),
        endDate:this.dateFormatYMD(item.planDate+86400000,"-"),
        state:this.addProductObj.state,
      }}).then(res => {
        if (res.status == 200) {
          cb(res.data);
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    delData(arr,index,item){
      arr.splice(index,1)
      this.countPrice(this.totalPrice,item,'stockPrice','-')
      this.countPrice(this.saleTotalPrice,item,'ratio','-')
    },
    copyData(item){
      this.checkDayList=[]
      this.copyToOtherDay = true
      this.copyDataObj = item
    },
    handleSelect(item,ee,flag){
      this.$set(ee,'resourceId',item.id)
      this.$set(ee,'resourceNameEn',item.nameEn)
      this.$set(ee,'resourceNameCn',item.nameCn)
      if(item.cityId){
        this.$set(ee,'startLinkId',item.cityId)
        this.$set(ee,'startLinkNameEn',item.cityName)
        this.$set(ee,'startLinkName',item.cityNameCn)
        this.$set(ee,'linkType',1)
      }else if(item.countryId){
        this.$set(ee,'startLinkId',item.countryId)
        this.$set(ee,'startLinkNameEn',item.countryName)
        this.$set(ee,'startLinkName',item.countryNameCn)
        this.$set(ee,'linkType',0)
      }else{
        this.$set(ee,'startLinkId',item.countryId)
        this.$set(ee,'startLinkNameEn',item.countryName)
        this.$set(ee,'startLinkName',item.countryNameCn)
        this.$set(ee,'linkType',2)
      }
      var obj = JSON.parse(JSON.stringify(item))
      obj.stockListResults=[]
      obj.customProductAreas=[]
      this.$set(ee,'resourceDetail',JSON.stringify(obj))
      this.$set(ee,'checkProductList',item.stockListResults)
      if(item.stockListResults.length>0&&flag==1){
        this.changeSelect(item.stockListResults[0].stockId,ee)
      }
      if(item.productType==1){
        this.$set(ee,'productType',5)
      }
    },
    changeSelect(value,item){
      if(item.checkProductList&&item.checkProductList.length>0&&value){
        var obj = item.checkProductList.find(e=>e.stockId==value)
        if(obj){
          if(obj.priceList&&obj.priceList.length>0){
            this.$set(item.details[0],'stockPrice',obj.priceList[0].price)
            this.$set(item.details[0],'ratio',obj.priceList[0].price)
            this.$set(item.details[0],'currency',obj.priceList[0].currency)
          }
          this.$set(item.details[0],'productName',obj.productNameCn)
          this.$set(item.details[0],'productId',obj.productId)
          this.$set(item.details[0],'stockId',obj.stockId)
          this.$set(item.details[0],'stockDetailObj',obj)
        }
      }
    },
    sureCopy(){
      this.copyToOtherDay = false
      this.checkDayListFlag = false
      if(this.copyDataObj){
        this.addDayProduct(this.copyDataObj,1)
      }else{
        this.addDayProduct(this.addProductObj,2)
      }
    },
    addProductObjMethod(productObj,obj,item){
      var addObj = JSON.parse(JSON.stringify(productObj))
      this.$set(addObj,'stayDate',this.dateFormatYMD(obj.planDate,"-"))
      this.$set(addObj,'day',obj.planDay)
      this.$set(addObj,'isEdit',true)
      var i=1;
      this.checkBudgetDetail.planDayList.forEach(e=>{
        if(e.productList&&e.productList.length>0){
          i+=e.productList.length
        }
      })
      this.$set(addObj.details[0].stockDetailObj,'billNumber',i)
      if(!this.copyDataObj){
        if(addObj.state==1||addObj.state==3||addObj.state==5||addObj.state==7||addObj.state==10){
          this.$set(addObj.details[0],'stockNumber',1)
        }else{
          this.$set(addObj.details[0],'stockNumber',this.checkBudgetDetail.useNumber)
        }
        this.$set(addObj.details[0].stockDetailObj.priceList[0],'priceCompany',this.stockTypeMap[addObj.state].priceCompany)
        this.$set(addObj.details[0].stockDetailObj.priceList[0],'useTime',this.stockTypeMap[addObj.state].useTime)
      }else{
        this.countPrice(this.totalPrice,this.copyDataObj,'stockPrice')
        this.countPrice(this.saleTotalPrice,this.copyDataObj,'ratio')
      }
      if(item){
        this.handleSelect(item,addObj,1)
      }
      if(obj.productList){
        obj.productList.push(addObj)
      }else{
        this.$set(obj,'productList',[addObj])
      }
    },
    addDayProduct(productObj,index){
      var cityIds = []
      this.checkDayList.forEach(e=>{
        var obj = this.checkBudgetDetail.planDayList.find(ee=>ee.planDay==e)
        if(index==2&&productObj.state==2){
          obj.cityList.forEach(ee=>{
            if(cityIds.findIndex(eee=>eee.cityId==ee.cityId)==-1){
              cityIds.push({
                cityId:ee.cityId,
                planDate:obj.planDate
              })
            }
          })
        }else{
          this.addProductObjMethod(productObj,obj)
        }
      })
      if(cityIds.length>0){
        cityIds.forEach(ee=>{
          new Api('resource').fastStockList({page:1,size:6,q:{
            productType:0,
            startDate:this.dateFormatYMD(ee.planDate,"-"),
            endDate:this.dateFormatYMD(ee.planDate+86400000,"-"),
            state:this.addProductObj.state,
            cityId:ee.cityId
          }}).then(res => {
            if (res.status == 200) {
              var obj = this.checkBudgetDetail.planDayList.find(eee=>eee.planDate==ee.planDate)
              if(res.data.length==0){
                this.addProductObjMethod(productObj,obj)
              }else{
                res.data.forEach(item=>{
                  this.addProductObjMethod(productObj,obj,item)
                })
              }
            }
          })
        })
      }
    },
    closeDialog(){
      this.addUseTimeBox=false
      getBudgetInfo(this.checkBudgetDetail.id)
    },
    addProduct(item){
      this.checkDayList=[]
      this.copyToOtherDay = true
      this.copyDataObj = null
      this.addProductObj.state = item.state
      this.addProductObj.productTypeName = item.type
    }
  },
  mounted(){
    this.height = document.documentElement.clientHeight-230;
    this.$Bus.$on('changePlanInfo',data=>{
      this.checkBudgetDetail = data.budgetMain
    })
  },
  beforeDestroy(){
    this.$Bus.$off("changePlanInfo");
  },
}
</script>

<style lang="scss" scoped>
.title{
  background: #e1f5f3;
  padding: 0.1rem 0.4rem;
  font-weight: bold;
  color: black;
  >p:first-child{
    font-size: 0.18rem;
    margin-bottom: 0.05rem;
  }
}
.order_list{
  display: flex;
  padding: 0.1rem 0.4rem;
  background: #e1f5f3;
  >li{
    display: flex;
    margin-right: 0.1rem;
    .typeDiv{
      width: 0.3rem;
      height: 0.25rem;
      background: #02A0C6;;
      text-align: center;
      border-radius: 20px;
      color: white;
      line-height: 0.25rem;
    }
  }
}
.addFast{
  /deep/ .el-dialog__body{
    background-color: #F7F7F7;
    padding-bottom: 0rem;
    position: relative;
  }
  /deep/ .el-dialog__header{
    padding:0;
  }
  /deep/ .el-dialog{
    margin-top:10vh !important;
  }
  .label{
    text-align: center;
  }
  font-size:0.12rem;
  .tableTitle{
    display:flex;
    margin-bottom:10px;
    padding-top:20px;
    margin-left: 0.5rem;
  }
  .dayQuan{
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    font-weight: bold;
    text-align: center;
    line-height: 0.4rem;
    background: #fff;
    color: #000;
    margin-bottom: 0.1rem;
    cursor: pointer;
  }
  .daybox{
    background-color: white;
    margin: 0 0 10px 10px;
    display: flex;
    color: black;
    padding: 0.1rem;
    /deep/ .el-input__inner{
      width: 100%;
      height: 0.27rem;
      border: none;
      border-bottom: 1px solid #000;
      border-radius: 0px;
    }
    .productBox{
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.18);
      display: flex;
      padding: 0.05rem;
      align-items: center;
    }
  }
  .labelone{
    padding: 0 0.05rem;
  }
}
//去掉number输入框的上下箭头
::v-deep .def-input-number input::-webkit-inner-spin-button,
::v-deep .def-input-number input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}
::v-deep .def-input-number input[type='number'] {
  appearance: textfield;
}
</style>